import React, { useState, useEffect, useCallback, useRef } from "react";
import ReactDOM from "react-dom";
import { about } from "../data/Data";
import SectionDivider from "../common/SectionDivider";
import { Link } from "react-router-dom";

const allImages = [
  { src: "/assets/img/about-11.jpg", alt: "Event Entrance" },
  { src: "/assets/img/about-12.jpg", alt: "Heritage Building" },
  { src: "/assets/img/about-13.jpg", alt: "Royal Garden View" },
  { src: "/assets/img/about-14.jpg", alt: "Lush Peacock Lawns" },
  { src: "/assets/img/about-15.jpg", alt: "Royal Wedding Setup" },
  { src: "/assets/img/about-16.jpg", alt: "Sunset Courtyard" },
  { src: "/assets/img/about-17.jpg", alt: "Floral Event Decor" },
  { src: "/assets/img/about-18.jpg", alt: "Evening Lighting Decor" },
];

// Helper component for count-up animation
function Counter({ count }) {
  const [displayCount, setDisplayCount] = useState(0);
  useEffect(() => {
    let start = 0;
    const end = parseInt(count);
    if (start === end) return;
    let stepTime = Math.abs(Math.floor(2000 / end));
    let timer = setInterval(() => {
      start += 1;
      setDisplayCount(start);
      if (start === end) clearInterval(timer);
    }, stepTime);
    return () => clearInterval(timer);
  }, [count]);
  return <h2 className="mb-1">{displayCount}</h2>;
}

// Lightbox component with 3D Stack Peek Previews & Perfectly Spaced Nav Buttons
function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  const lightboxRef = useRef(null);

  useEffect(() => {
    function handleKey(e) {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft") onPrev();
      else if (e.key === "ArrowRight") onNext();
    }
    const origOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKey);
    return () => {
      document.body.style.overflow = origOverflow;
      document.removeEventListener("keydown", handleKey);
    };
  }, [onClose, onPrev, onNext]);

  const prevIndex = (currentIndex - 1 + images.length) % images.length;
  const nextIndex = (currentIndex + 1) % images.length;

  const current = images[currentIndex];
  const prevImage = images[prevIndex];
  const nextImage = images[nextIndex];

  return ReactDOM.createPortal(
    <>
      <style>{`
        .hk-lightbox-stage {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          max-width: 1100px;
          height: 85vh;
          box-sizing: border-box;
        }

        /* 3D PEEK PREVIEW CARDS BEHIND MAIN CARD */
        .hk-peek-card {
          position: absolute;
          top: 50%;
          border-radius: 18px;
          overflow: hidden;
          background: #FFFFFF;
          border: 2px solid rgba(212, 175, 55, 0.4);
          box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5);
          cursor: pointer;
          transition: all 0.45s cubic-bezier(0.16, 1, 0.3, 1);
          opacity: 0.55;
          width: 320px;
          height: 420px;
          z-index: 995;
          filter: brightness(0.75) blur(1px);
        }

        .hk-peek-card:hover {
          opacity: 0.85;
          filter: brightness(0.95) blur(0px);
        }

        .hk-peek-prev {
          left: 5%;
          transform: translateY(-50%) scale(0.82) rotate(-4deg);
        }

        .hk-peek-next {
          right: 5%;
          transform: translateY(-50%) scale(0.82) rotate(4deg);
        }

        .hk-peek-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* MAIN FRONT CARD */
        .hk-lightbox-card-container {
          position: relative;
          max-width: 650px;
          width: 90%;
          border-radius: 22px;
          padding: 12px 12px 16px 12px;
          background: #FFFFFF;
          border: 2px solid rgba(212, 175, 55, 0.6);
          box-shadow: 0 32px 90px rgba(0, 0, 0, 0.75), 0 0 30px rgba(254, 161, 22, 0.2);
          display: flex;
          flex-direction: column;
          align-items: center;
          z-index: 1000;
          transition: transform 0.4s ease;
          box-sizing: border-box;
        }

        /* PERFECTLY SPACED NAV BUTTONS */
        .hk-lightbox-nav-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: linear-gradient(135deg, #FEA116 0%, #E38A12 100%);
          border: 2.5px solid #FFFFFF;
          color: #050E1A;
          font-size: 1.4rem;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 1005;
          box-shadow: 0 10px 26px rgba(0, 0, 0, 0.45), 0 0 18px rgba(254, 161, 22, 0.45);
          transition: all 0.25s ease;
        }

        .hk-lightbox-nav-btn:hover {
          transform: translateY(-50%) scale(1.14);
          background: #FFFFFF;
          color: #FEA116;
          border-color: #FEA116;
        }

        .hk-lightbox-nav-left {
          left: -48px;
        }

        .hk-lightbox-nav-right {
          right: -48px;
        }

        .hk-lightbox-close {
          position: absolute;
          top: -18px;
          right: -18px;
          width: 40px;
          height: 40px;
          background: #0B1D37;
          border: 2.5px solid #FEA116;
          font-size: 1.15rem;
          color: #FFF;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 1010;
          box-shadow: 0 8px 22px rgba(0,0,0,0.55);
          transition: all 0.25s ease;
        }

        .hk-lightbox-close:hover {
          background: #FEA116;
          color: #0B1D37;
          transform: scale(1.12);
        }

        .hk-lightbox-main-img {
          width: 100%;
          height: 440px;
          border-radius: 16px;
          object-fit: cover;
          box-shadow: 0 8px 24px rgba(11, 29, 55, 0.12);
        }

        .hk-lightbox-caption-badge {
          margin-top: 12px;
          font-family: 'Cinzel', serif;
          font-size: 0.95rem;
          font-weight: 700;
          color: #0B1D37;
          text-align: center;
          padding: 6px 22px;
          border-radius: 50px;
          background: #FAF6F0;
          border: 1px solid rgba(212, 175, 55, 0.45);
          letter-spacing: 0.04em;
        }

        @media (max-width: 992px) {
          .hk-peek-card {
            display: none;
          }
          .hk-lightbox-stage {
            max-width: 100vw;
            padding: 0 10px;
          }
          .hk-lightbox-card-container {
            width: calc(100% - 20px);
            max-width: 94vw;
            padding: 10px 10px 14px 10px;
            border-radius: 18px;
          }
          .hk-lightbox-nav-btn {
            width: 44px;
            height: 44px;
            font-size: 1.15rem;
          }
          .hk-lightbox-nav-left {
            left: 10px;
            z-index: 1015;
          }
          .hk-lightbox-nav-right {
            right: 10px;
            z-index: 1015;
          }
          .hk-lightbox-close {
            top: 10px;
            right: 10px;
            width: 36px;
            height: 36px;
            font-size: 1rem;
            z-index: 1020;
          }
          .hk-lightbox-main-img {
            height: min(320px, 48vh);
            border-radius: 12px;
          }
          .hk-lightbox-caption-badge {
            font-size: 0.8rem;
            padding: 4px 14px;
            margin-top: 8px;
          }
        }
      `}</style>

      <div
        role="dialog"
        aria-modal="true"
        aria-label="Image preview"
        className="lightbox-overlay"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(11, 29, 55, 0.94)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99999999,
          backdropFilter: "blur(14px)",
          WebkitBackdropFilter: "blur(14px)",
          userSelect: "none"
        }}
        ref={lightboxRef}
        tabIndex={-1}
        onClick={(e) => {
          if (e.target === lightboxRef.current) {
            onClose();
          }
        }}
      >
        <div className="hk-lightbox-stage">
          {/* Previous Image Peek Card Behind */}
          <div
            className="hk-peek-card hk-peek-prev"
            onClick={onPrev}
            title={`View previous: ${prevImage.alt}`}
          >
            <img src={prevImage.src} alt={prevImage.alt} className="hk-peek-img" />
          </div>

          {/* Active Main Front Modal Card */}
          <div
            className="hk-lightbox-card-container"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              aria-label="Close lightbox"
              className="hk-lightbox-close"
            >
              ✕
            </button>

            {/* Prev Button - Spaced slightly further out (-48px) */}
            <button
              onClick={onPrev}
              aria-label="Previous image"
              className="hk-lightbox-nav-btn hk-lightbox-nav-left"
            >
              <span>❮</span>
            </button>

            {/* Main HD Image */}
            <img src={current.src} alt={current.alt} className="hk-lightbox-main-img" />

            {/* Next Button - Spaced slightly further out (-48px) */}
            <button
              onClick={onNext}
              aria-label="Next image"
              className="hk-lightbox-nav-btn hk-lightbox-nav-right"
            >
              <span>❯</span>
            </button>

            {/* Caption Badge */}
            <div className="hk-lightbox-caption-badge">
              {current.alt} <span style={{ color: "#FEA116", marginLeft: "6px" }}>({currentIndex + 1} of {images.length})</span>
            </div>
          </div>

          {/* Next Image Peek Card Behind */}
          <div
            className="hk-peek-card hk-peek-next"
            onClick={onNext}
            title={`View next: ${nextImage.alt}`}
          >
            <img src={nextImage.src} alt={nextImage.alt} className="hk-peek-img" />
          </div>
        </div>
      </div>
    </>,
    document.body
  );
}

// Ultra-Modern Interactive Image Gallery Canvas component
function ImageScroller({ images, onImageClick }) {
  const [activeTab, setActiveTab] = useState("all");
  const [isPausedRow1, setIsPausedRow1] = useState(false);
  const [isPausedRow2, setIsPausedRow2] = useState(false);
  const touchTimer1Ref = useRef(null);
  const touchTimer2Ref = useRef(null);

  const handleTouchStart1 = () => {
    setIsPausedRow1(true);
    if (touchTimer1Ref.current) clearTimeout(touchTimer1Ref.current);
  };

  const handleTouchEnd1 = () => {
    if (touchTimer1Ref.current) clearTimeout(touchTimer1Ref.current);
    touchTimer1Ref.current = setTimeout(() => {
      setIsPausedRow1(false);
    }, 2000);
  };

  const handleTouchStart2 = () => {
    setIsPausedRow2(true);
    if (touchTimer2Ref.current) clearTimeout(touchTimer2Ref.current);
  };

  const handleTouchEnd2 = () => {
    if (touchTimer2Ref.current) clearTimeout(touchTimer2Ref.current);
    touchTimer2Ref.current = setTimeout(() => {
      setIsPausedRow2(false);
    }, 2000);
  };

  const [likes, setLikes] = useState(() => {
    const initial = {};
    images.forEach((_, idx) => {
      initial[idx] = Math.floor(18 + (idx * 7) % 35);
    });
    return initial;
  });
  const [likedMap, setLikedMap] = useState({});

  const toggleLike = (e, index) => {
    e.stopPropagation();
    setLikes((prev) => ({
      ...prev,
      [index]: likedMap[index] ? prev[index] - 1 : prev[index] + 1,
    }));
    setLikedMap((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const categoryMap = {
    0: "Weddings & Events",
    1: "Resort Architecture",
    2: "Lush Lawns",
    3: "Lush Lawns",
    4: "Weddings & Events",
    5: "Lush Lawns",
    6: "Weddings & Events",
    7: "Weddings & Events",
  };

  const filteredImages = images
    .map((img, idx) => ({
      ...img,
      originalIndex: idx,
      category: categoryMap[idx] || "Resort Highlights",
    }))
    .filter((img) => {
      if (activeTab === "all") return true;
      if (activeTab === "events") return img.category === "Weddings & Events";
      if (activeTab === "lawns") return img.category === "Lush Lawns";
      if (activeTab === "resort") return img.category === "Resort Architecture";
      return true;
    });

  // Guarantee continuous infinite marquee across all desktop monitor resolutions (even 4K)
  let baseImages = [...filteredImages];
  if (baseImages.length > 0) {
    while (baseImages.length < 18) {
      baseImages = [...baseImages, ...filteredImages];
    }
  }
  const scrollImages = [...baseImages, ...baseImages];
  const scrollImagesReverse = [...scrollImages].reverse();

  const renderCard = ({ src, alt, originalIndex, category }, idx, keyPrefix) => {
    const isLiked = likedMap[originalIndex];
    const count = likes[originalIndex] || 22;

    return (
      <div
        key={`${keyPrefix}-${src}-${idx}`}
        className="scroller-item"
        onClick={() => onImageClick(originalIndex)}
        tabIndex={0}
        role="listitem"
        aria-label={`Open image: ${alt}`}
      >
        <div className="scroller-img-wrapper">
          <img src={src} alt={alt} draggable={false} loading="lazy" />
          <div className="scroller-hover-overlay">
            <div className="scroller-zoom-btn" title="View Fullscreen">
              <i className="fas fa-search-plus"></i>
            </div>
          </div>
        </div>

        <div className="scroller-item-footer">
          <div className="scroller-caption-group">
            <div className="scroller-title">{alt}</div>
            <span className="scroller-cat-tag">{category}</span>
          </div>

          <button
            type="button"
            className={`scroller-like-btn ${isLiked ? "scroller-like-btn--liked" : ""}`}
            onClick={(e) => toggleLike(e, originalIndex)}
            title="Like photo"
          >
            <i className={`${isLiked ? "fas" : "far"} fa-heart`}></i>
            <span>{count}</span>
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <style>{`
        /* GALLERY FILTER TABS */
        .hk-gallery-tabs-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          margin-bottom: 24px;
        }

        .hk-gallery-tab-btn {
          background: rgba(255, 255, 255, 0.85);
          border: 1.5px solid rgba(212, 175, 55, 0.35);
          color: #0B1D37;
          font-family: 'Poppins', sans-serif;
          font-size: 0.84rem;
          font-weight: 600;
          padding: 8px 20px;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 14px rgba(11, 29, 55, 0.05);
        }

        .hk-gallery-tab-btn:hover,
        .hk-gallery-tab-btn--active {
          background: linear-gradient(135deg, #FEA116 0%, #D4AF37 100%);
          color: #050E1A;
          border-color: transparent;
          box-shadow: 0 8px 20px rgba(254, 161, 22, 0.35);
          transform: translateY(-2px);
        }

        /* SCROLLER CANVAS */
        .scroller-wrapper {
          overflow-x: auto;
          overflow-y: hidden;
          width: 100%;
          padding: 10px 0 16px;
          user-select: none;
          position: relative;
          -webkit-overflow-scrolling: touch;
          scroll-behavior: smooth;
        }

        .scroller-wrapper::-webkit-scrollbar {
          display: none;
        }

        .scroller {
          display: flex;
          width: max-content;
          min-width: 100%;
          gap: 26px;
          animation: hk-scroll-left 110s linear infinite;
        }

        .scroller--reverse {
          animation: hk-scroll-right 110s linear infinite !important;
        }

        .scroller-wrapper:hover .scroller,
        .scroller-wrapper:active .scroller,
        .scroller--paused {
          animation-play-state: paused !important;
        }

        /* CRAZY MODERN CARD - ENLARGED SIZE & NO TILT ON HOVER */
        .scroller-item {
          background: #FFFFFF;
          padding: 14px 14px 18px 14px;
          border-radius: 20px;
          border: 1.5px solid rgba(212, 175, 55, 0.35);
          box-shadow: 0 12px 30px rgba(11, 29, 55, 0.08);
          cursor: pointer;
          transition: all 0.38s cubic-bezier(0.16, 1, 0.3, 1);
          user-select: none;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 275px;
          position: relative;
          overflow: hidden;
        }

        .scroller-item:hover {
          transform: translateY(-8px) scale(1.03);
          box-shadow: 0 22px 50px rgba(254, 161, 22, 0.24);
          border-color: #FEA116;
        }

        .scroller-img-wrapper {
          position: relative;
          width: 100%;
          height: 175px;
          border-radius: 14px;
          overflow: hidden;
          background: #0B1D37;
        }

        .scroller-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .scroller-item:hover img {
          transform: scale(1.1);
        }

        /* Hover Quick Overlay */
        .scroller-hover-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(11, 29, 55, 0.3) 0%, rgba(11, 29, 55, 0.85) 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .scroller-item:hover .scroller-hover-overlay {
          opacity: 1;
        }

        .scroller-zoom-btn {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background: linear-gradient(135deg, #FEA116 0%, #D4AF37 100%);
          color: #050E1A;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.1rem;
          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);
          transform: scale(0.8);
          transition: transform 0.3s ease;
        }

        .scroller-item:hover .scroller-zoom-btn {
          transform: scale(1);
        }

        .scroller-item-footer {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 12px;
        }

        .scroller-caption-group {
          text-align: left;
          overflow: hidden;
        }

        .scroller-title {
          font-family: 'Cinzel', serif;
          font-size: 0.84rem;
          font-weight: 700;
          color: #0B1D37;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .scroller-cat-tag {
          font-family: 'Poppins', sans-serif;
          font-size: 0.72rem;
          color: #53647C;
          display: block;
        }

        .scroller-like-btn {
          background: #FAF6F0;
          border: 1px solid rgba(30, 62, 114, 0.15);
          color: #53647C;
          border-radius: 50px;
          padding: 3px 10px;
          font-size: 0.74rem;
          cursor: pointer;
          transition: all 0.25s ease;
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .scroller-like-btn--liked,
        .scroller-like-btn:hover {
          background: rgba(254, 161, 22, 0.15);
          color: #e11d48;
          border-color: #e11d48;
        }

        @keyframes hk-scroll-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        @keyframes hk-scroll-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }

        @media (max-width: 768px) {
          .scroller-wrapper {
            padding: 6px 12px 12px 12px !important;
          }
          .scroller {
            animation: hk-scroll-left 90s linear infinite !important;
            gap: 12px !important;
          }
          .scroller--reverse {
            animation: hk-scroll-right 90s linear infinite !important;
          }
          .scroller-item {
            width: 190px !important;
            padding: 8px 8px 12px 8px !important;
            border-radius: 14px !important;
            flex-shrink: 0 !important;
          }
          .scroller-img-wrapper {
            height: 125px !important;
          }
          .scroller-title {
            font-size: 0.75rem !important;
          }
        }
      `}</style>

      {/* Interactive Category Filter Pills */}
      <div className="hk-gallery-tabs-wrapper">
        <button
          className={`hk-gallery-tab-btn ${activeTab === "all" ? "hk-gallery-tab-btn--active" : ""}`}
          onClick={() => setActiveTab("all")}
        >
          <i className="fas fa-layer-group me-1"></i> All Moments ({images.length})
        </button>
        <button
          className={`hk-gallery-tab-btn ${activeTab === "resort" ? "hk-gallery-tab-btn--active" : ""}`}
          onClick={() => setActiveTab("resort")}
        >
          <i className="fas fa-hotel me-1"></i> Royal Resort
        </button>
        <button
          className={`hk-gallery-tab-btn ${activeTab === "events" ? "hk-gallery-tab-btn--active" : ""}`}
          onClick={() => setActiveTab("events")}
        >
          <i className="fas fa-glass-cheers me-1"></i> Weddings & Events
        </button>
        <button
          className={`hk-gallery-tab-btn ${activeTab === "lawns" ? "hk-gallery-tab-btn--active" : ""}`}
          onClick={() => setActiveTab("lawns")}
        >
          <i className="fas fa-tree me-1"></i> Lush Lawns
        </button>
      </div>

      {/* Dual Marquee Gallery Rows (Opposing Directions) */}
      <div className="d-flex flex-column gap-2">
        {/* Row 1: Right to Left */}
        <div 
          className="scroller-wrapper" 
          aria-label="Scrolling image gallery row 1"
          onTouchStart={handleTouchStart1}
          onTouchEnd={handleTouchEnd1}
          onMouseEnter={() => setIsPausedRow1(true)}
          onMouseLeave={() => setIsPausedRow1(false)}
        >
          <div className={`scroller ${isPausedRow1 ? "scroller--paused" : ""}`} role="list">
            {scrollImages.map((item, idx) => renderCard(item, idx, "row1"))}
          </div>
        </div>

        {/* Row 2: Left to Right */}
        <div 
          className="scroller-wrapper" 
          aria-label="Scrolling image gallery row 2"
          onTouchStart={handleTouchStart2}
          onTouchEnd={handleTouchEnd2}
          onMouseEnter={() => setIsPausedRow2(true)}
          onMouseLeave={() => setIsPausedRow2(false)}
        >
          <div className={`scroller scroller--reverse ${isPausedRow2 ? "scroller--paused" : ""}`} role="list">
            {scrollImagesReverse.map((item, idx) => renderCard(item, idx, "row2"))}
          </div>
        </div>
      </div>

      {/* View All Moments Gallery Button */}
      <div className="text-center mt-4 pt-1 mb-2">
        <Link
          to="/gallery"
          className="btn rounded-pill px-4 py-2 fw-bold shadow-sm"
          style={{
            background: "linear-gradient(135deg, #FEA116 0%, #D4AF37 100%)",
            color: "#050E1A",
            fontSize: "0.88rem",
            letterSpacing: "0.06em",
            border: "1.5px solid rgba(254, 161, 22, 0.6)",
            boxShadow: "0 6px 20px rgba(254, 161, 22, 0.35)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
          }}
        >
          VIEW ALL MOMENTS <i className="fas fa-arrow-right ms-2" />
        </Link>
      </div>
    </>
  );
}

export default function About({ isTop = false }) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = useCallback((index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  }, []);

  const closeLightbox = useCallback(() => setLightboxOpen(false), []);

  const goPrev = useCallback(() => {
    setCurrentIndex((prev) => (prev - 1 + allImages.length) % allImages.length);
  }, []);

  const goNext = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % allImages.length);
  }, []);

  return (
    <>
      <style>{`
        .hk-gallery-section {
          background: transparent;
          padding-top: 85px;
          padding-bottom: 0;
          margin-top: 0;
        }

        /* REALISTIC ASYMMETRICAL WALL HANGING PHOTO FRAMES */
        .hk-wall-hanging-card {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          cursor: pointer;
          user-select: none;
          margin-top: 26px;
          transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        }

        /* 3D BRASS WALL PIN NAIL */
        .hk-pin-nail {
          position: absolute;
          top: -26px;
          left: 50%;
          transform: translateX(-50%);
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: radial-gradient(circle at 35% 35%, #FFF2B3 0%, #FEA116 55%, #7A5700 100%);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5), inset 0 1px 2px rgba(255, 255, 255, 0.9);
          z-index: 10;
        }

        .hk-pin-nail::after {
          content: "";
          position: absolute;
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%);
          width: 8px;
          height: 6px;
          background: rgba(11, 29, 55, 0.5);
          border-radius: 50%;
          filter: blur(1.5px);
        }

        /* HANGING STRING SVG */
        .hk-pin-string-svg {
          position: absolute;
          top: -24px;
          left: 50%;
          transform: translateX(-50%);
          width: 85%;
          height: 28px;
          overflow: visible;
          z-index: 5;
          pointer-events: none;
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.35));
        }

        /* REALISTIC WHITE POLAROID FRAME */
        .hk-polaroid-frame {
          background: #FFFFFF;
          border-radius: 14px;
          padding: 9px 9px 12px 9px;
          box-shadow: 
            0 16px 36px rgba(11, 29, 55, 0.14),
            0 4px 12px rgba(0, 0, 0, 0.08),
            inset 0 0 0 1px rgba(212, 175, 55, 0.3);
          border: 1.5px solid rgba(212, 175, 55, 0.45);
          width: 100%;
          position: relative;
          z-index: 8;
          transition: all 0.35s ease;
        }

        /* Asymmetrical Frame Tilts & Heights */
        .hk-frame-0 { transform: rotate(-2.5deg); }
        .hk-frame-0 .hk-polaroid-img-box { height: 155px; }

        .hk-frame-1 { transform: rotate(2.5deg); margin-top: 36px; }
        .hk-frame-1 .hk-polaroid-img-box { height: 135px; }

        .hk-frame-2 { transform: rotate(2deg); }
        .hk-frame-2 .hk-polaroid-img-box { height: 135px; }

        .hk-frame-3 { transform: rotate(-2.8deg); margin-top: 36px; }
        .hk-frame-3 .hk-polaroid-img-box { height: 160px; }

        /* Hover elevation without extra tilt */
        .hk-wall-hanging-card:hover {
          transform: translateY(-8px) scale(1.03) !important;
        }

        .hk-wall-hanging-card:hover .hk-polaroid-frame {
          box-shadow: 
            0 24px 50px rgba(254, 161, 22, 0.28),
            0 8px 20px rgba(11, 29, 55, 0.15);
          border-color: #FEA116;
        }

        .hk-polaroid-img-box {
          width: 100%;
          border-radius: 8px;
          overflow: hidden;
          background: #0B1D37;
        }

        .hk-polaroid-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .hk-wall-hanging-card:hover .hk-polaroid-img {
          transform: scale(1.08);
        }

        .hk-polaroid-title {
          font-family: 'Cinzel', serif;
          font-size: 0.78rem;
          font-weight: 700;
          color: #0B1D37;
          text-align: center;
          margin-top: 8px;
          letter-spacing: 0.04em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        @media (max-width: 768px) {
          .hk-frame-0 .hk-polaroid-img-box,
          .hk-frame-3 .hk-polaroid-img-box {
            height: 120px;
          }
          .hk-frame-1 .hk-polaroid-img-box,
          .hk-frame-2 .hk-polaroid-img-box {
            height: 100px;
          }
          .hk-wall-hanging-card {
            margin-top: 24px;
          }
          .hk-pin-nail {
            top: -24px;
            width: 13px;
            height: 13px;
          }
          .hk-pin-string-svg {
            top: -22px;
            height: 24px;
          }
          .hk-frame-1,
          .hk-frame-3 {
            margin-top: 24px;
          }
        }
      `}</style>
      <section className={`hk-about-section ${isTop ? "hk-top-section" : ""} my-0 position-relative`} style={{ padding: "54px 0 32px 0", background: "linear-gradient(180deg, #FAF6F0 0%, #F2EAE0 50%, #FAF6F0 100%)" }} aria-label="About HariKunj Resort">
        <div className="container" style={{ maxWidth: "1140px", margin: "0 auto" }}>
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <h6 className="section-title text-start text-primary text-uppercase">
                About Us
              </h6>
              <h1 className="mb-4">
                Welcome to <span className="text-primary">HariKunj Resort</span>
              </h1>
              <p className="mb-4">
                Experience the Royal Charm of Rajasthan at Hari Kunj Resort,
                nestled in the heart of Jodhpur. Where luxury meets Heritage,
                offering a serene escape amidst to the gateway Thar Desert.
              </p>
              <div className="row g-3 pb-2">
                {about.map(({ icon, count, text }, idx) => (
                  <div
                    key={idx}
                    className="col-4"
                  >
                    <div className="hk-counter-card">
                      {icon}
                      <Counter count={count} />
                      <p className="hk-counter-label">{text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 4 Realistic Wall-Hung Photo Frames with Nails & Hanging Twine */}
            <div className="col-lg-6 mt-4 mt-lg-0 pt-lg-2">
              <div className="row g-3 g-md-4 align-items-center">
                {allImages.slice(0, 4).map(({ src, alt }, index) => (
                  <div key={src} className="col-6 position-relative">
                    <div
                      className={`hk-wall-hanging-card hk-frame-${index}`}
                      onClick={() => openLightbox(index)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          openLightbox(index);
                        }
                      }}
                      aria-label={`Open image: ${alt}`}
                    >
                      {/* 3D Brass Push Pin Nail */}
                      <div className="hk-pin-nail"></div>

                      {/* Real Braided Hanging String SVG */}
                      <svg className="hk-pin-string-svg" viewBox="0 0 120 30" preserveAspectRatio="none">
                        <line x1="60" y1="4" x2="14" y2="30" stroke="#C59B27" strokeWidth="3" strokeLinecap="round" />
                        <line x1="60" y1="4" x2="106" y2="30" stroke="#C59B27" strokeWidth="3" strokeLinecap="round" />
                      </svg>

                      {/* Real Polaroid Photo Frame */}
                      <div className="hk-polaroid-frame">
                        <div className="hk-polaroid-img-box">
                          <img src={src} alt={alt} className="hk-polaroid-img" loading="lazy" draggable={false} />
                        </div>
                        <div className="hk-polaroid-title">{alt}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Perfectly centered Section Separator Line */}
        <div className="my-3 my-md-4">
          <SectionDivider />
        </div>

        {/* Gallery Section - inside exact same section wrapper */}
        <div className="hk-gallery-section pt-0">
          <div className="container">
            <div className="text-center mx-auto mb-4" style={{ maxWidth: "800px" }}>
              <h6 className="section-title text-center text-primary text-uppercase" style={{ letterSpacing: "3px" }}>
                Gallery
              </h6>
              <h2 className="mb-3" style={{ fontFamily: "'Cinzel', serif", fontWeight: "700", color: "#0B1D37" }}>
                Our Visual <span className="text-primary">Canvas</span>
              </h2>
              <div 
                style={{
                  width: "60px",
                  height: "2px",
                  background: "linear-gradient(90deg, transparent, #FEA116, transparent)",
                  margin: "12px auto"
                }}
              />
              <p 
                className="text-muted" 
                style={{ 
                  fontStyle: "italic", 
                  fontSize: "1.05rem", 
                  color: "#53647C",
                  lineHeight: "1.6"
                }}
              >
                "Captured moments of heritage, lush green lawns, and regal celebrations. Let your eyes wander through the visual poetry of HariKunj."
              </p>
            </div>
          </div>

          {/* Scrolling image strip - visible on all devices */}
          <ImageScroller images={allImages} onImageClick={openLightbox} />
        </div>
      </section>

      {lightboxOpen && (
        <Lightbox
          images={allImages}
          currentIndex={currentIndex}
          onClose={closeLightbox}
          onPrev={goPrev}
          onNext={goNext}
        />
      )}
    </>
  );
}
